import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nContext";

export default function NotFound() {
  const { locale, t } = useI18n();
  return (
    <div className="mx-auto flex max-w-xl flex-col items-center px-5 py-24 text-center md:px-8" data-testid="not-found-page">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#0f5c3f]">404</p>
      <h1
        className="mt-3 text-4xl leading-tight text-[#0b3d5c] md:text-5xl"
        style={{ fontFamily: "Georgia, 'Times New Roman', serif" }}
      >
        {t("notFound.title")}
      </h1>
      <p className="mt-4 text-sm text-[#4b5f70]">{t("notFound.text")}</p>
      <Link
        to={`/${locale}`}
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#0f5c3f] px-6 py-3 text-sm font-semibold text-white hover:bg-[#0d4d35]"
        data-testid="not-found-back-home"
      >
        {t("notFound.backHome")}
      </Link>
    </div>
  );
}
